
import { useMemo } from 'react';

/**
 * Groups evaluators into eIdeas, bIdeas, and otherIdeas.
 */
export function useIdeaSplit(evaluators) {
  return useMemo(() => {
    const empty = { eIdeas: [], bIdeas: [], otherIdeas: [] };
    if (!Array.isArray(evaluators) || evaluators.length === 0) return empty;

    return evaluators.reduce((acc, item) => {
      const flag = item?.businessScoreCardFlag;
      if (flag === 'E') acc.eIdeas.push(item);
      else if (flag === 'B') acc.bIdeas.push(item);
      else acc.otherIdeas.push(item);
      return acc;
    }, empty);
  }, [evaluators]);
}